var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconShares64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_11443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5949 47.238C13.8564 47.238 15.6897 45.4047 15.6897 43.1432C15.6897 40.8817 13.8564 39.0483 11.5949 39.0483C9.33333 39.0483 7.5 40.8817 7.5 43.1432C7.5 45.4047 9.33333 47.238 11.5949 47.238Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9032 31.3704C27.1647 31.3704 28.9981 29.537 28.9981 27.2755C28.9981 25.014 27.1647 23.1807 24.9032 23.1807C22.6417 23.1807 20.8083 25.014 20.8083 27.2755C20.8083 29.537 22.6417 31.3704 24.9032 31.3704Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2113 41.096C40.4728 41.096 42.3062 39.2626 42.3062 37.0011C42.3062 34.7396 40.4728 32.9062 38.2113 32.9062C35.9498 32.9062 34.1165 34.7396 34.1165 37.0011C34.1165 39.2626 35.9498 41.096 38.2113 41.096Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5436 23.6926C54.8051 23.6926 56.6384 21.8593 56.6384 19.5978C56.6384 17.3363 54.8051 15.5029 52.5436 15.5029C50.2821 15.5029 48.4487 17.3363 48.4487 19.5978C48.4487 21.8593 50.2821 23.6926 52.5436 23.6926Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5129 40.5664L23.1517 30.813",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4463 29.4199L35.413 34.1573",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9866 34.157L49.904 23.0103",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_11443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconShares64);
export default __webpack_public_path__ + "static/media/pictogramBeaconShares64.f614188f23704a2a971cc838f6064ec2.svg";
export { ForwardRef as ReactComponent };